import CompanyCapegoIntegrationSettings from "./CompanyCapegoIntegrationSettings.js";
import Model from "../Model.js";

/**
 * CompanyIntegrationSettings defines the integration of a company with third-party data providers.
 *
 * @param {CompanyCapegoIntegrationSettings} capegoIntegrationSettings - Defines the integration of the company with Capego
 */
export default class CompanyIntegrationSettings extends Model {
	constructor({
		capegoIntegrationSettings = new CompanyCapegoIntegrationSettings(),
	} = {}) {
		super(...arguments);

		this._capegoIntegrationSettings = capegoIntegrationSettings;
	}

	getCapegoIntegrationSettings() {
		return this._capegoIntegrationSettings;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.capegoIntegrationSettings = this._capegoIntegrationSettings;

		return properties;
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.capegoIntegrationSettings &&=
			CompanyCapegoIntegrationSettings.materialize(
				data.capegoIntegrationSettings,
				context,
			);
	}
}
